export enum DestinacaoVinculo {
  CIDADAO = 'CIDADAO',
  SERVIDOR = 'SERVIDOR'
}
